interface ArrowsDownWithPeopleSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ArrowsDownWithPeopleSVG = ({
  color,
  style,
}: ArrowsDownWithPeopleSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="58"
    height="52"
    viewBox="0 0 58 52"
    fill="none"
  >
    <path
      d="M38.4621 41.5146C38.4621 44.0151 37.4975 46.2878 35.9177 47.9827C35.9066 47.327 35.8511 46.6879 35.7513 46.0767C35.4631 44.2318 34.2103 43.3038 32.392 43.1871L28.9939 45.8933L25.5958 43.1871C23.7831 43.3038 22.5247 44.2318 22.2364 46.0767C22.1422 46.6935 22.0868 47.3325 22.0701 47.9827C20.4958 46.2878 19.5312 44.0207 19.5312 41.5201C19.5312 36.2856 23.7664 32.0347 28.9884 32.0347C34.2103 32.0347 38.451 36.2801 38.451 41.5201L38.4621 41.5146Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.0043 39.0029C32.0043 41.1201 30.6628 42.8371 29.0053 42.8371C27.3479 42.8371 26.0063 41.1201 26.0063 39.0029C26.0063 36.8858 27.3479 35.1688 29.0053 35.1688C30.6628 35.1688 32.0043 36.8858 32.0043 39.0029Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.9233 47.9826C34.1938 49.8386 31.7325 51 29.0051 51C26.2778 51 23.8109 49.8386 22.0869 47.9771C22.098 47.3269 22.1534 46.6935 22.2532 46.0711C22.5415 44.2263 23.7998 43.2983 25.6125 43.1816L29.0107 45.8877L32.4088 43.1816C34.2215 43.2983 35.4799 44.2263 35.7681 46.0711C35.8624 46.6824 35.9178 47.3269 35.9344 47.9771L35.9233 47.9826Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57.0002 31.1901C57.0002 33.6906 56.0356 35.9634 54.4557 37.6582C54.4446 37.0025 54.3892 36.3635 54.2894 35.7522C54.0012 33.9074 52.7484 32.9794 50.9301 32.8627L47.532 35.5688L44.1339 32.8627C42.3212 32.9794 41.0628 33.9074 40.7745 35.7522C40.6803 36.369 40.6249 37.0081 40.6082 37.6582C39.0339 35.9634 38.0693 33.6962 38.0693 31.1956C38.0693 25.9612 42.3045 21.7102 47.5264 21.7102C52.7484 21.7102 56.9891 25.9556 56.9891 31.1956L57.0002 31.1901Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M50.5361 28.6785C50.5361 30.7956 49.1946 32.5127 47.5371 32.5127C45.8796 32.5127 44.5381 30.7956 44.5381 28.6785C44.5381 26.5613 45.8796 24.8443 47.5371 24.8443C49.1946 24.8443 50.5361 26.5613 50.5361 28.6785Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M54.4551 37.6582C52.7255 39.5142 50.2642 40.6755 47.5369 40.6755C44.8095 40.6755 42.3427 39.5142 40.6187 37.6526C40.6297 37.0025 40.6852 36.369 40.785 35.7466C41.0732 33.9018 42.3316 32.9738 44.1443 32.8571L47.5424 35.5633L50.9405 32.8571C52.7532 32.9738 54.0116 33.9018 54.2999 35.7466C54.3941 36.3579 54.4495 37.0025 54.4662 37.6526L54.4551 37.6582Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.9308 31.1901C19.9308 33.6906 18.9663 35.9634 17.3864 37.6582C17.3753 37.0025 17.3199 36.3635 17.2201 35.7522C16.9318 33.9074 15.679 32.9794 13.8608 32.8627L10.4626 35.5688L7.06452 32.8627C5.25182 32.9794 3.99346 33.9074 3.7052 35.7522C3.61096 36.369 3.55552 37.0081 3.53889 37.6582C1.96456 35.9634 1 33.6962 1 31.1956C1 25.9612 5.23519 21.7102 10.4571 21.7102C15.679 21.7102 19.9197 25.9556 19.9197 31.1956L19.9308 31.1901Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.4672 28.6785C13.4672 30.7956 12.1257 32.5127 10.4682 32.5127C8.81075 32.5127 7.46924 30.7956 7.46924 28.6785C7.46924 26.5613 8.81075 24.8443 10.4682 24.8443C12.1257 24.8443 13.4672 26.5613 13.4672 28.6785Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.3867 37.6582C15.6572 39.5142 13.1959 40.6755 10.4685 40.6755C7.74113 40.6755 5.2743 39.5142 3.55029 37.6526C3.56138 37.0025 3.61681 36.369 3.7166 35.7466C4.00485 33.9018 5.26321 32.9738 7.07592 32.8571L10.474 35.5633L13.8722 32.8571C15.6849 32.9738 16.9432 33.9018 17.2315 35.7466C17.3257 36.3579 17.3812 37.0025 17.3978 37.6526L17.3867 37.6582Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.636 1H23.364C22.0584 1 21 2.64287 21 4.66945V5.33055C21 7.35713 22.0584 9 23.364 9H34.636C35.9416 9 37 7.35713 37 5.33055V4.66945C37 2.64287 35.9416 1 34.636 1Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.19678 14L10.4686 16.7451L15.7459 14"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42.2651 14L47.5425 16.7451L52.8143 14"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.7285 22.5075L29.0059 25.2526L34.2832 22.5075"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.7285 16.7451L29.0059 19.4846L34.2832 16.7451"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowsDownWithPeopleSVG;
